export const TRACKING_CATEGORY = "login";
export const TRACKING_ACTION = "login-module";
export const TRACKING_LABEL = "click-prime-continue-no-discount";
